import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, ArrowLeft } from "lucide-react";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6 relative overflow-hidden">
      <div className="noise" />
      <div className="absolute inset-0 grid-lines opacity-30" />
      <Link to="/" data-testid="back-home" className="absolute top-8 left-8 flex items-center gap-2 text-white/50 hover:text-white font-mono-p text-sm transition-colors">
        <ArrowLeft size={16} /> Retour au site
      </Link>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
        className="relative w-full max-w-md bg-[rgba(12,12,13,0.7)] backdrop-blur-xl border border-white/10 clip-frame p-10"
      >
        <div className="flex items-center gap-2 mb-8">
          <span className="w-2 h-2 rounded-full bg-[var(--primary)]" />
          <span className="font-display font-extrabold text-xl tracking-tight">FIXE<span className="text-primary-c">DRONE</span></span>
        </div>
        <span className="font-mono-p text-xs uppercase tracking-[0.25em] text-primary-c">Espace privé</span>
        <h1 className="font-display font-bold text-4xl tracking-tight mt-4 leading-none">Administration</h1>
        <p className="text-white/55 mt-4 leading-relaxed">Connectez-vous avec le compte Google autorisé pour gérer les demandes de contact reçues.</p>

        <button
          onClick={handleLogin}
          data-testid="google-login-btn"
          className="group mt-10 w-full inline-flex items-center justify-center gap-3 bg-white text-black font-medium px-6 py-4 rounded-full hover:bg-[var(--primary)] transition-colors duration-300"
        >
          <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
          Continuer avec Google
          <ArrowUpRight size={16} className="group-hover:rotate-45 transition-transform duration-300" />
        </button>
        <p className="text-white/30 text-xs mt-6 font-mono-p">Accès réservé à info@fixedrone.com</p>
      </motion.div>
    </div>
  );
}
